/*
 *   File : sip.js
 *   Author URI : https://evoqins.com
 *   Description : Table component which enables customers to view the Active SIP list.
 *   Integrations : null
 *   Version : v1.1
 */

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../Form-elements";
import Icon from "../Icon/icon";

import Colors from "../../Styles/color.module.scss";

const SIPTable = (props) => {
    const navigate = useNavigate();
    const [showArrow, setShowArrow] = useState(0);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {

        function _handleScroll() {
            setScreenWidth(window.innerWidth);
        }

        window.addEventListener('scroll', _handleScroll);

        return () => {
            window.removeEventListener('scroll', _handleScroll)
        }
    }, []);

    const SIP_COLUMN = [
        {
            name: 'Scheme name',
            selector: row => row['name'],
            sortable: false,
            left: true,
            width: "380px",
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name"
                    onClick={() => _handleCardClick(row)}>
                    <div className="p-2 border-radius-8px border-all border-bright-gray w-unset flex-shrink-0">
                        <img src={row['image']} alt={row['name']}
                            width={36}
                            height={36}
                            className="object-fit-contain" />
                    </div>
                    <div className="d-flex flex-column gap-12px min-width-0">
                        <p className="color-black e-poppins-medium e-font-sm-16-14 line-height-24px mb-0 text-nowrap">{row['name']}</p>
                        {
                            row['sip_tag'] !== null &&
                            <span className="border-radius-16px border-all border-bright-gray py-1 padding-12px-lr color-black e-poppins-medium e-font-10 line-height-18px w-fit-content">
                                {row['sip_tag']}
                            </span>
                        }
                    </div>
                </div>
        },
        {
            name: "Amount",
            width: "120px",
            selector: row => row['amount'],
            sortable: false,
            left: true,
            cell: row =>
                <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    <span className="e-inter-medium">₹</span>{(row['amount'] ?? 0).toLocaleString('En-IN')}
                </p>
        },
        {
            name: "First installment",
            width: "185px",
            selector: row => row['is_first_order'],
            sortable: false,
            left: true,
            cell: row => {
                const label = row['is_first_order'] === true ? 'First Installment' : 'Subsequent installment';
                return (
                    <div className="text-start w-100 text-nowrap" onClick={() => _handleCardClick(row)}>
                        <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0">
                            {label}
                        </p>
                    </div>
                );
            }
        },
        {
            name: "SIP creation date",
            width: "160px",
            selector: row => row['created_date'],
            sortable: false,
            left: true,
            cell: row =>
                <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    {row['created_date'] ?? '-'}
                </p>
        },
        // {
        //     name: 'First Sip Installment',
        //     selector: row => row['is_first_order'],
        //     sortable: false,
        //     left: true,
        //     width: "180px",
        //     cell: row =>
        //         <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0"
        //         >
        //             {row.is_first_order ? 'Yes' : 'No'}</p>
        // },
        {
            name: 'First Sip Installment',
            selector: row => row['is_first_order'],
            sortable: false,
            left: true,
            width: "200px",
            cell: row => {
                let value = '-';

                if (row.is_first_order === true) {
                    value = 'First Installment';
                } else if (row.is_first_order === false) {
                    value = 'Sub. Installment';
                }

                return (
                    <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0">
                        {value}
                    </p>
                );
            }
        },
        {
            name: 'Sip Start Date',
            selector: row => row['sip_start_date'],
            sortable: false,
            left: true,
            width: "180px",
            cell: row =>
                <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0"
                >
                    {row.sip_start_date}</p>
        },
        {
            name: "SIP start date",
            width: "135px",
            selector: row => row['sip_start_date'],
            sortable: false,
            left: true,
            cell: row =>
                <p className="color-black e-poppins-medium e-font-14 line-height-18px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    {row['sip_start_date'] ?? '-'}
                </p>
        },
        {
            name: 'Next installment date',
            selector: row => row['next_sip_date'] ?? row['next_due'],
            sortable: true,
            left: true,
            width: "195px",
            cell: row => {
                const value = row['next_sip_date'] ?? row['next_due'] ?? '-';
                return (
                    <p className="color-black e-poppins-semi-bold e-font-14 line-height-18px mb-0"
                        onClick={() => _handleCardClick(row)}>
                        {value}
                    </p>
                );
            }
        },
        {
            name: 'Status',
            selector: row => row['status'],
            sortable: false,
            left: true,
            width: "130px",
            cell: row =>
                <p className={`${row.status === 'Cancellation pending' ? 'color-yellow-orange' : 'color-sea-green'} text-center e-poppins-medium e-font-14 line-height-20px mb-0`}
                    onClick={() => _handleCardClick(row)}>
                    {row['status'] ?? '-'}
                </p>
        },
        {
            name: '',
            sortable: false,
            left: true,
            width: "24px",
            cell: row =>

                <div className={`e-sip-hover text-start ${showArrow === row.sip_id ? 'show' : ''}`}>
                    <Icon icon="arrow-right1"
                        size={24}
                        color={Colors.black} />
                </div>

        }

    ];

    const SIP_COLUMN_MOBILE = [
        {
            name: 'Scheme name',
            selector: row => row['name'],
            sortable: false,
            left: true,
            width: "320px",
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name"
                    onClick={() => _handleCardClick(row)}>
                    <div className="p-2 border-radius-8px border-all border-bright-gray w-unset flex-shrink-0">
                        <img src={row['image']} alt={row['name']}
                            width={24}
                            height={24}
                            className="object-fit-contain" />
                    </div>
                    <div className="d-flex flex-column gap-6px min-width-0">
                        <p className="color-black e-poppins-medium e-font-sm-12 line-height-22px mb-0 text-nowrap">{row['name']}</p>
                        {
                            row['sip_tag'] !== null &&
                            <span className="border-radius-16px border-all border-bright-gray py-1 padding-12px-lr color-black e-poppins-medium e-font-10 line-height-18px w-fit-content">
                                {row['sip_tag']}
                            </span>
                        }
                    </div>
                </div>
        },
        {
            name: "Amount",
            width: "90px",
            selector: row => row['amount'],
            sortable: false,
            left: true,
            cell: row =>
                <p className="color-black e-poppins-medium e-font-12 line-height-18px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    <span className="e-inter-medium">₹</span>{(row['amount'] ?? 0).toLocaleString('En-IN')}
                </p>
        },
        {
            name: "First installment",
            width: "175px",
            selector: row => row['is_first_order'],
            sortable: false,
            left: true,
            cell: row => {
                const label = row['is_first_order'] === true ? 'First Installment' : 'Subsequent installment';
                return (
                    <div className="text-start w-100 text-nowrap" onClick={() => _handleCardClick(row)}>
                        <p className="color-black e-poppins-medium e-font-12 line-height-18px mb-0">
                            {label}
                        </p>
                    </div>
                );
            }
        },
        {
            name: "SIP creation date",
            width: "110px",
            selector: row => row['created_date'],
            sortable: false,
            left: true,
            cell: row =>
                <p className="color-black e-poppins-medium e-font-12 line-height-18px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    {row['created_date'] ?? '-'}
                </p>
        },
        {
            name: "SIP start date",
            width: "100px",
            selector: row => row['sip_start_date'],
            sortable: false,
            left: true,
            cell: row =>
                <p className="color-black e-poppins-medium e-font-12 line-height-18px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    {row['sip_start_date'] ?? '-'}
                </p>
        },
        {
            name: 'Next installment date',
            width: "165px",
            selector: row => row['next_sip_date'] ?? row['next_due'],
            sortable: false,
            left: true,
            cell: row => {
                const value = row['next_sip_date'] ?? row['next_due'] ?? '-';
                return (
                    <p className="color-black e-poppins-medium e-font-12 line-height-18px mb-0"
                        onClick={() => _handleCardClick(row)}>
                        {value}
                    </p>
                );
            }
        },
        {
            name: 'Status',
            width: "100px",
            selector: row => row['status'],
            sortable: false,
            left: true,
            cell: row =>
                <p className={`${row.status === 'Cancellation pending' ? 'color-yellow-orange' : 'color-sea-green'} e-poppins-medium e-font-12 line-height-18px mb-0`}
                    onClick={() => _handleCardClick(row)}>
                    {row['status'] ?? '-'}
                </p>
        }
    ];

    const _handleCardClick = (row) => {
        if (row.is_goal) {
            navigate("/sip/sip-goal-summary", { state: { sip_id: row.sip_id } });
        } else {
            navigate("/sip/sip-summary", { state: { sip_id: row.sip_id } });
        }

        props.showSipDetail(row);
    }

    const _handleRowHover = (row) => {
        setShowArrow(row.sip_id)
    }

    const _handleRowRemoveHover = () => {
        setShowArrow(0);
    }

    const customStyles = {
        headRow: {
            style: {
                fontSize: "16px",
                paddingBottom: "8px !important",
            }
        },
        headCells: {
            style: {
                justifyContent: 'flex-start',
            },
        },
        rows: {
            style: {
                padding: "16px",
                '&:hover': {
                    boxShadow: '0px 12px 16px 0px rgba(50, 50, 71, 0.08)',
                },
            },
        },
        cells: {
            style: {
                justifyContent: "flex-start",
            }
        }
    };

    const customStylesMobile = {
        headRow: {
            style: {
                paddingRight: "0px",
                fontSize: "14px",
                paddingBottom: "8px !important",
            }
        },
        headCells: {
            style: {
                justifyContent: 'flex-start',
            },
        },
        cells: {
            style: {
                justifyContent: "flex-start",
                '&:first-child': {
                    padding: "0px 0 0px 0px !important"
                },
                '&:last-child': {
                    padding: "0px 0px 0px 0 !important"
                },
            }
        }
    };

    return (
        <div className="e-mobile-table">
            <DataTable columns={screenWidth > 576 ? SIP_COLUMN : SIP_COLUMN_MOBILE}
                data={props.data}
                pagination={false}
                customStyles={screenWidth > 576 ? customStyles : customStylesMobile}
                onRowMouseEnter={_handleRowHover}
                onRowMouseLeave={_handleRowRemoveHover}
                rowClick={_handleCardClick} />
        </div>
    )
}

export default SIPTable;